/**
 * Detect lazy-route / chunk failures (incl. Vue Router "Couldn't resolve component").
 * Common after deploy when cached index.html references removed hashed chunks.
 */
export function isRouteModuleLoadError(error: unknown): error is Error {
    if (!(error instanceof Error)) {
        return false
    }

    return (
        error.message.includes("Couldn't resolve component") ||
        error.message.includes('Failed to fetch dynamically imported module') ||
        error.message.includes('Importing a module script failed') ||
        error.message.includes('Load failed') ||
        (error.name === 'TypeError' &&
            (error.message.includes('dynamic import') ||
                error.message.includes('Load failed')))
    )
}
